<template>
  <b-nav-item-dropdown right no-caret>
    <template slot="button-content">
      <i class="fa fa-sign-out"></i>
    </template>
    <b-dropdown-item @click="logout"><i class="fa fa-lock"></i> Sair</b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<script>
  export default {
    name: 'header-dropdown',
    data () {
      return { itemsCount: 42, loading: false }
    },
    methods: {
      logout () {
        this.loading = true
        this.$http.post(`auth/logout`).then((response) => {
          this.$store.commit('setUser', null)
          this.$store.commit('setToken', null)
          window.localStorage.setItem('origami_admin_user', null)
          window.localStorage.setItem('origami_admin_token', null)
          this.loading = false
          this.$router.push({name: 'Login'})
        }).catch((response) => {
          this.loading = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/HeaderDropdown.vue